export default "__VITE_ASSET__D4C_gfnt__"